<template>
  <nav v-show="isNavBarVisible" id="navbar-main" class="navbar is-fixed-top">
    <div class="navbar-brand">
      <a class="navbar-item is-hidden-desktop" @click.prevent="menuToggleMobile">
        <b-icon :icon="menuToggleMobileIcon"/>
      </a>
      <a class="navbar-item is-hidden-mobile" @click.prevent="menuToggle">
        <b-icon :icon="menuToggleIcon"/>
      </a>
      <!-- <div class="navbar-item"> -->
        <!-- <nav-bar-menu class="has-divider is-hidden-mobile has-dropdown is-hoverable is-mega">
          <b-icon icon="menu" custom-size="default"/>
          <span>Sample Menu</span>
          <div slot="dropdown" class="navbar-dropdown">
            <div class="columns">
                <div class="column">
                  <h1 class="title is-6 is-mega-menu-title">Sub Menu Title</h1>

                  <router-link to="/profile" class="navbar-item" exact-active-class="is-active">
                    <b-icon icon="account" custom-size="default"/>
                    <span>My Profile</span>
                  </router-link>
                  <a class="navbar-item">
                    <b-icon icon="settings" custom-size="default"/>
                    <span>Settings</span>
                  </a>
                  <a class="navbar-item">
                    <b-icon icon="email" custom-size="default"/>
                    <span>Messages</span>
                  </a>
                  <hr class="navbar-divider">
                  <a class="navbar-item">
                    <b-icon icon="logout" custom-size="default"/>
                    <span>Log Out</span>
                  </a>
                </div>
                <div class="column">
                  <h1 class="title is-6 is-mega-menu-title">Sub Menu Title</h1>
                  1
                </div>
                <div class="column">
                  <h1 class="title is-6 is-mega-menu-title">Sub Menu Title</h1>
                  1
                </div>
            </div>
          </div>
        </nav-bar-menu> -->

        <!-- <div class="control">
          <input class="input" placeholder="Search everywhere...">
        </div>
      </div> -->
    </div>
    <div class="navbar-brand is-right">
      <a class="navbar-item navbar-item-menu-toggle is-hidden-desktop" @click.prevent="menuNavBarToggle">
        <b-icon :icon="menuNavBarToggleIcon" custom-size="default"/>
      </a>
    </div>
    <div class="navbar-menu fadeIn animated faster" :class="{'is-active':isMenuNavBarActive}">
      <div class="navbar-end">
        <router-link :to="{ name: 'deal-details', params: { id: 'new'}, query: { status_id: 'd:statuses:13',} }" class="navbar-item has-background-warning has-divider">
           <!-- is-desktop-icon-only -->
          <!-- <b-icon icon="cart-plus" custom-size="top-menu" class="has-badge-bottom" /> -->
          <span>Добавить заявку</span>
        </router-link>

        <router-link :to="{ name: 'notifications' }" class="navbar-item has-divider is-desktop-icon-only">
          <b-icon icon="more" custom-size="top-menu" class="has-badge-bottom" :data-badge="counters.countUnread" />
          <span>Уведомления</span>
        </router-link>

        <router-link :to="{ name: 'calendar' }" class="navbar-item has-divider is-desktop-icon-only">
          <b-icon icon="calendar" custom-size="top-menu" />
          <span>Календарь</span>
        </router-link>

        <div class="navbar-item has-dropdown has-dropdown-with-icons">
          <a class="navbar-link is-arrowless">
            <user-avatar/>

            <div class="is-user-name">
              <span>{{ actor.document.name }}</span>
            </div>
          </a>
        </div>
        <!-- <nav-bar-menu class="has-divider has-user-avatar">
          <user-avatar/>

          <div class="is-user-name">
            <span>{{ actor.document.name }}</span>
          </div>


          <div slot="dropdown" class="navbar-dropdown">
            <router-link to="/profile" class="navbar-item" exact-active-class="is-active">
              <b-icon icon="account" custom-size="default"/>
              <span>Профиль</span>
            </router-link>
            <hr class="navbar-divider">
            <a class="navbar-item" @click="logout">
              <b-icon icon="logout" custom-size="default"></b-icon>
              <span>Выйти</span>
            </a>
          </div>
        </nav-bar-menu> -->
        <a class="navbar-item is-desktop-icon-only" title="Выйти" @click="logout">
          <b-icon icon="logout" custom-size="default"/>
          <span>Выйти</span>
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
// import NavBarMenu from '@/components/Layout/NavBarMenu'
import UserAvatar from '@/components/Layout/UserAvatar'

// @Component({
//   computed: {
//     ...mapState('ubic', [
//       'token',
//     ]),
//     ...mapGetters('ubic', [
//       'isAuthenticated',
//     ]),
//   },
//   methods: {
//     ...mapActions('ubic', [
//       'login', 'logout',
//     ]),
//   },
//   components: {
//     LoginForm,
//     FooterBar,
//     AsideMenu,
//     NavBar
//   }
// })
export default {
  name: 'NavBar',
  components: {
    UserAvatar,
    // NavBarMenu
  },
  data () {
    return {
      isMenuNavBarActive: false
    }
  },
  computed: {
    menuNavBarToggleIcon () {
      return (this.isMenuNavBarActive) ? 'close' : 'dots-vertical'
    },
    menuToggleMobileIcon () {
      return this.isAsideMobileExpanded ? 'backburger' : 'forwardburger'
    },
    menuToggleIcon () {
      return this.isAsideExpanded ? 'backburger' : 'forwardburger'
    },
    ...mapState([
      'isNavBarVisible',
      'isAsideMobileExpanded',
      'isAsideExpanded',
      'userName'
    ]),
    ...mapState('ubic', [
      'actor', 'counters'
    ])
  },
  methods: {
    ...mapActions('ubic', [
      'logout',
    ]),
    menuToggleMobile () {
      this.$store.commit('asideMobileStateToggle')
    },
    menuToggle () {
      this.$store.commit('asideStateToggle')
    },
    menuNavBarToggle () {
      this.isMenuNavBarActive = (!this.isMenuNavBarActive)
    },
    // logout () {
    //   this.$buefy.snackbar.open({
    //     message: 'Log out clicked',
    //     queue: false
    //   })
    // }
  }
}
</script>
